var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-container d-flex flex-column p-2",style:({'left': _vm.build.left +'px', 'top': _vm.build.top +'px'}),attrs:{"id":"tooltip"}},[_c('h5',[_vm._v(_vm._s(_vm.build.question))])])}
var staticRenderFns = []

export { render, staticRenderFns }